import React from 'react';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { Popover, PopoverBody } from 'reactstrap';

import { messages } from '../../../../../../_shared/i18n/messages';

import { updateNodeAttrs } from '../../core/commands';
import { imageViewPluginKey } from '../plugins/imageView';

import styles from './AltTooltip.module.scss';

const propTypes = {

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

};

const AltTooltip = (props) => {

	const { editorView } = props;

	const intl = useIntl();

	// Get image data from plugin state
	const { imageNode, imagePos } = imageViewPluginKey.getState(editorView.state);
	const alt = imageNode?.attrs?.alt || '';
	const target = editorView.nodeDOM(imagePos);

	const position = imageNode?.attrs?.position;
	const size = imageNode?.attrs?.size;

	const handleInputChange = (event) => {

		const value = event.target.value;

		updateNodeAttrs(
			imageNode.attrs,
			{ alt: value, title: value },
			imagePos,
		)(editorView.state, editorView.dispatch);

	};

	if (target) {

		return (
			<Popover
				key={`${position}-${size}`} // Trigger re-mount if image moves
				className={styles['description-container']}
				target={target}
				placement="bottom"
				fade={false}
				modifiers={[{
					name: 'flip',
					enabled: false,
				}]}
				hideArrow
				isOpen>
				<PopoverBody className="p-0">
					<div style={{ width: target.offsetWidth }}>
						<input
							className={styles['description-input']}
							name="alt"
							value={alt}
							placeholder={
								intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_PLACEHOLDER)
							}
							onChange={handleInputChange} />
						<span
							className={`pl-2 ${styles['icon-btn']}`}
							title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_HINT)}>
							<i className="far fa-question-circle" />
						</span>
					</div>
				</PopoverBody>
			</Popover>
		);

	}

	return <div />;

};

AltTooltip.propTypes = propTypes;

export default AltTooltip;
